'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const lib = {};
function add(translator, name) {
    name = name ?? translator.name;
    if (translator.hasOwnProperty(name)) {
        throw new ReferenceError('name exists');
    }
    Object.defineProperty(lib, name, {
        configurable: false,
        enumerable: true,
        get() {
            return translator;
        },
        set(v) {
            throw new SyntaxError(`Translator"${name}" exists!`);
        }
    });
}

exports.add = add;
exports.lib = lib;
